<h1 mat-dialog-title class="text-center mb-0 fw-bold mt-3">
    {{isEditing ? 'Edit' : 'Create'}} transfer recipient
</h1>

<mat-dialog-content>
    <div class="container-fluid p-2">
        <div class="row" [formGroup]="transferForm">
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Recipient name</mat-label>
                <mat-error>You need to enter the recipient name</mat-error>
                <input matInput placeholder="Ex: Jacob" formControlName="name" required>
                <mat-hint>Enter the recipient name</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Recipient phone number</mat-label>
                <mat-error>You need to enter the recipient phone number</mat-error>
                <input matInput placeholder="Ex: 514-755-7877" formControlName="phoneNumber" required>
                <mat-hint>Enter the recipient phone number</mat-hint>
            </mat-form-field>
        </div>
    </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button class="w-25" color="warn" [disabled]="isLoading">Close</button>
    <button (click)="onSubmitForm()" mat-raised-button class="w-25" color="primary"
        [disabled]="!transferForm.valid || isLoading">
        <span *ngIf="!isLoading">
            {{isEditing ?'Save' : 'Add'}}
        </span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>